import moment from "moment-timezone";

export const getCreateOrderRequests = (data, _volumeUnitConverter, version) => {
  const parseOrderDate = (orderDate) => {
    return orderDate === null || orderDate === undefined
      ? null
      : moment(orderDate).format("YYYY-MM-DD");
  };

  const latLng =
    data?.["SHIPLOCLAT"] || data?.["SHIPLOCLAN"]
      ? {
          lat: data?.["SHIPLOCLAT"],
          lng: data?.["SHIPLOCLAN"],
        }
      : null;

  function getPhoneNumber(phoneNumber) {
    if (
      phoneNumber === null ||
      phoneNumber === undefined ||
      phoneNumber === "N/A"
    ) {
      return null;
    }
    return phoneNumber;
  }

  const getPaymentType = (paymentType) => {
    if (paymentType === null || paymentType === undefined) {
      return "NONE";
    }

    if (paymentType.toUpperCase() === "POD") {
      return "NONE";
    }

    return "NONE";
  };

  return {
    id: data?.["CUSTOMER_ORDER_NO"] || null,
    contactPoint: {
      name: data?.["CUSTOMER_NAME"] || null,
      number: getPhoneNumber(data?.["CUSTOMER_PHONE_NO"]) || null,
      email: data?.["CUSTOMER_EMAIL"] || null,
    },
    teamId: data?.["TEAM_ID"],
    homebaseId: data?.["FULFILLMENT_LOC"] || null,
    sourceOrderId: data?.["CUSTOMER_ID"] || null,
    type: data?.["DELIVERYTYPE"],
    weight: {
      value: data?.["PACKAGEWEIGHT"] || null,
      unit: data?.["PACKAGEWEIGHTUNIT"],
    },
    volume: {
      value: data?.["PACKAGEVOLUME"],
      unit: data?.["PACKAGEVOLUMEUNIT"],
    },
    ...(version === "v2"
      ? {
          amount: {
            grossAmount: {
              amount: data?.["PACKAGEVALUE"],
              currency: data?.["PACKAGEVALUECURRENCY"],
            },
            netAmount: {
              amount: data?.["PACKAGEVALUE"],
              currency: data?.["PACKAGEVALUECURRENCY"],
            },
            amountToBeCollected: {
              amount: 0,
              currency: data?.["PACKAGEVALUECURRENCY"],
            },
          },
        }
      : {
          amountTransaction: {
            amount: {
              amount: data?.["PACKAGEVALUE"],
              currency: data?.["PACKAGEVALUECURRENCY"],
            },
            net: {
              amount: data?.["PACKAGEVALUE"],
            },
            gross: {
              amount: data?.["PACKAGEVALUE"],
            },
            exchangeType: getPaymentType(data?.["PAYMENT_TYPE"]),
          },
        }),
    slot: {
      start: data?.["DELIVERSTARTTIMEWINDOW"] || null,
      end: data?.["DELIVERENDTIMEWINDOW"] || null,
    },
    transactionDuration: data?.["AMOUNTTRANSACTIONDURATION"],
    locationAddress: {
      formattedAddress: data?.["ADDR_LINE1"],
      subLocalityName: data?.["SUBLOCALITY"],
      localityName: data?.["SUBDISTRICT"],
      city: data?.["CITY"],
      state: data?.["STATE"],
      pincode: data?.["ZIPCODE"],
      country: data?.["COUNTRY"],
      locationType: data?.["LOCATION_TYPE"],
    },
    latLng,
    orderDate: parseOrderDate(data?.["ORDER_DATE"]),
    date: parseOrderDate(data?.["ORDER_DATE"]),
    customerPromisedDate: data?.["CUSTOMER_PROMISE_DATE"] || null,
    // customProperties: {
    //   wmsStatus: data?.["FULLFILLMENT_STATUS"] || null,
    //   deliveryType: data?.["DELIVERYTYPE"] || null,
    //   orderSource: data?.["AUTHORIZE_CLIENT"] || null,
    // },
    locationId: data?.["DELIVERADDRESSID"],
  };
};
